import { Splide } from '@splidejs/react-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'
import { oneOfType, arrayOf, node, array, object, string } from 'prop-types'
import SplideJsSlide from '@ui/component/splidejs/SplideJsSlide'

const SplideJs = ({ slides, cssClass, config }) => {
  const defaultConfig = {
    type: 'slide',
    perPage: 1,
    perMove: 1,
    lazyLoad: 'nearby'
  }
  config = { ...defaultConfig, ...config }

  const renderSlides = () => {
    return slides.map((slide, index) => {
      return <SplideJsSlide slide={slide} key={`splidejs-${index}-${cssClass}`} />
    })
  }

  return (
    <Splide options={config} className={cssClass}>
      {renderSlides()}
    </Splide>
  )
}

SplideJs.propTypes = {
  config: object,
  cssClass: string,
  slides: oneOfType([array, arrayOf(node)])
}

export default SplideJs
